import { useFetch } from './useFetch';
import type { UtxoBlocksResponse } from '../api/types';

interface UseBlocksOptions {
  offset?: number;
  startHeight?: number;
}

export function useBlocks(count: number = 20, options: UseBlocksOptions = {}) {
  const params = new URLSearchParams();
  params.set('count', String(count));

  if (options.startHeight != null) {
    params.set('start_height', String(options.startHeight));
  } else if (options.offset != null) {
    params.set('offset', String(options.offset));
  }

  return useFetch<UtxoBlocksResponse>(
    `/utxo/blocks/recent?${params.toString()}`
  );
}
